import * as React from 'react';
var CloseIcon = function () { return (React.createElement("svg", { width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M18 6 6 18M6 6l12 12", stroke: "#545763", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }))); };
export default CloseIcon;
